module.exports = __webpack_public_path__ + "img/icon_stores.f6a625f3.png";